<template>
  <div v-if="isVisible" class="fixed inset-0 z-50 overflow-y-auto">
    <!-- Backdrop -->
    <div class="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" @click="closeModal"></div>

      <!-- Modal -->
      <div :class="`relative inline-block w-full ${widthClass} mx-auto my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-lg`">
        <!-- Header -->
        <div class="flex items-center justify-between mb-4 px-4 pt-2">
          <h3 class="text-lg font-medium text-gray-900">
            <slot name="header">{{ title }}</slot>
          </h3>
          <button
            @click="closeModal"
            class="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>

        <!-- Content -->
        <div class="mt-2 px-4">
          <slot name="content"></slot>
        </div>

        <!-- Footer -->
        <div class="flex justify-end space-x-3 mt-6 px-4 pb-2">
          <slot name="footer">
            <button
              v-if="showCloseButton"
              @click="closeModal"
              class="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 border border-transparent rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
            >
              Close
            </button>
            <button
              v-if="!showCloseButton"
              @click="closeModal"
              class="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 border border-transparent rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
            >
              Cancel
            </button>
            <button
              v-if="!showCloseButton"
              @click="confirm"
              class="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Confirm
            </button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseModal',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Modal'
    },
    width: {
      type: String,
      default: 'md', // sm, md, lg, xl, 2xl, 3xl, 4xl, 5xl, 6xl, 7xl
      validator: function (value) {
        return ['sm', 'md', 'lg', 'xl', '2xl', '3xl', '4xl', '5xl', '6xl', '7xl'].indexOf(value) !== -1
      }
    },
    showCloseButton: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    widthClass() {
      const widthMap = {
        'sm': 'max-w-sm',
        'md': 'max-w-md', 
        'lg': 'max-w-lg',
        'xl': 'max-w-xl',
        '2xl': 'max-w-2xl',
        '3xl': 'max-w-3xl',
        '4xl': 'max-w-4xl',
        '5xl': 'max-w-5xl',
        '6xl': 'max-w-6xl',
        '7xl': 'max-w-7xl'
      };
      return widthMap[this.width] || 'max-w-md';
    }
  },
  emits: ['close', 'confirm'],
  methods: {
    closeModal() {
      this.$emit('close');
    },
    confirm() {
      this.$emit('confirm');
    }
  }
}
</script>
